import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  GET_LIST_ALL_CHECKLIST_REPORTS_REQUEST,
  GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS,
  SEARCH,
  GET_MODAL_QUESTIONS_REQUEST,
  GET_MODAL_QUESTIONS_SUCCESS,
  SHARE_CSV,
  GET_ALL_SELECTS_REQUEST,
  GET_ALL_SELECTS_SUCCESS,
  SET_LOADING_SELECTS
} from './client-report-checklist-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const getAllReportsChecklistRequest = payload => {
  return {
    type: GET_LIST_ALL_CHECKLIST_REPORTS_REQUEST,
    payload
  };
};

export const getAllReportsChecklistSuccess = payload => {
  return {
    type: GET_LIST_ALL_CHECKLIST_REPORTS_SUCCESS,
    payload
  };
};

export const getModalQuestionsRequest = payload => {
  return {
    type: GET_MODAL_QUESTIONS_REQUEST,
    payload
  };
};

export const getModalQuestionsSuccess = (payload: any) => {
  return {
    type: GET_MODAL_QUESTIONS_SUCCESS,
    payload
  };
};

export const getAllSelectsRequest = (payload?: any) => {
  return {
    type: GET_ALL_SELECTS_REQUEST,
    payload
  };
};

export const getAllSelectsSuccess = (payload: any) => {
  return {
    type: GET_ALL_SELECTS_SUCCESS,
    payload
  };
};

export const shareCsv = (exportType: 'csv' | 'xlsx', filters) => {
  return {
    type: SHARE_CSV,
    exportType,
    filters
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};
